<div class="h-screen flex flex-col">
  <maximizer-outlook-session-refresh-notice />

  @if (showMenu()) {
    <maximizer-outlook-menu
      [pageTitle]="pageTitle()"
      [isAuthorizedRoute]="isAuthorizedRoute()"
      [canNavigateBack]="canNavigateBack()"
      [deeplink]="deeplink()"
    >
    </maximizer-outlook-menu>
  }

  <div class="flex-1 overflow-hidden">
    <router-outlet></router-outlet>
  </div>
</div>
